import { Button } from "$components/button/button";
import { DialogBody } from "$components/dialog/dialog-body";
import { DialogContainer } from "$components/dialog/dialog-container";
import { DialogHeader } from "$components/dialog/dialog-header";
import { WarningIcon } from "$components/icons";
import { styled, Typography } from "@material-ui/core";
import type { FC } from "react";
import { FormattedMessage } from "react-intl";

const HeaderWithIcon = styled("div")(() => ({
  display: "flex",
  justifyContent: "flex-start",
  gap: "16px",
  marginBottom: "16px",
}));

const ButtonContainer = styled("div")(() => ({
  width: "100%",
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  gap: "24px",
}));

const StyledIcon = styled(WarningIcon)(({ theme }) => ({
  color: theme.palette.primary.main,
}));

export const UnsavedDataConfirmationDialog: FC<
  {
    onConfirm: () => void;
    onCancel: () => void;
  } & React.ComponentProps<typeof DialogContainer>
> = ({ open, onConfirm, onCancel, ...restProps }) => {
  return (
    <DialogContainer open={open} {...restProps}>
      <HeaderWithIcon>
        <StyledIcon viewBox="0 0 32 32" fontSize="large" />
        <DialogHeader title="You have unsaved data" />
      </HeaderWithIcon>
      <DialogBody>
        <Typography color="textSecondary" paragraph>
          <FormattedMessage
            id="unsavedDataConfirmationDialog.body"
            defaultMessage="You have unsaved data that hasn't synced to the server. If you log out now, this data may be lost."
          />
        </Typography>
        <ButtonContainer>
          <Button variant="text" color="primary" onClick={onConfirm}>
            <FormattedMessage
              id="unsavedDataConfirmationDialog.logoutButton"
              defaultMessage="Log out anyway"
            />
          </Button>
          <Button variant="contained" color="primary" onClick={onCancel}>
            <FormattedMessage
              id="unsavedDataConfirmationDialog.stayButton"
              defaultMessage="Stay logged in"
            />
          </Button>
        </ButtonContainer>
      </DialogBody>
    </DialogContainer>
  );
};
